module.exports = __webpack_public_path__ + "static/media/nowayround-regular-webfont.60d13ac1.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/nowayround-regular-webfont.woff
// module id = 569
// module chunks = 0